import * as React from "react";
import { useEffect } from "react";
import styled, { css } from "styled-components";
import { Fonts } from "../../ui/_assets/fonts";
import { mobile } from "../../ui/_themes/constants/";
import {
  iPadLandscapeOnly,
  iPadPortraitOnly
} from "../../ui/_utils/styleUtils";
import { ActivityMobile } from "./Activity";
import { DialogMobile } from "./Dialogs";
import { DisplayModeSwitcher } from "./DisplayModeSwitcher/Mobile/DisplayModeSwitcher.container";
import { UiBlocker } from "../../v2/components/UiBlocker";

const StyleContainer = styled.div`
  pointer-events: none;
  touch-action: manipulation;
  font-family: ${mobile.defaultFont};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  * {
    box-sizing: border-box;
  }

  /* font-size: calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width]))); */

  font-size: calc(16px + (32 - 16) * ((100vw - 320px) / (720 - 320)));

  @media (orientation: landscape) {
    font-size: calc(
      16px + (32 - 16) * ((var(--innerHeight, 100vh) - 320px) / (720 - 320))
    );
  }

  ${iPadPortraitOnly(css`
    font-size: 1.25em;
  `)};

  ${iPadLandscapeOnly(css`
    font-size: 1.57em;
  `)};

  /* @see KEYPAD-1547 and KEYPAD-1554 */
  @media only screen and (-webkit-device-pixel-ratio: 2) and (min-device-width: 768px) and (max-device-height: 767px) and (orientation: landscape) {
    font-size: 1em;
  }
`;

export const Mobile = () => {
  // window.orientation is undefined in Native apps
  // we should assume that the phone starts in portrait
  const isPortrait = () =>
    typeof window.orientation === "undefined"
      ? true
      : window.orientation === 0 ||
        window.orientation === 180 ||
        window.orientation === -180;

  const {
    clientWidth: width,
    clientHeight: height
  } = window.document.documentElement;

  const initWidth = width;
  const initHeight = height;
  const initOrientation = isPortrait() ? "PORTRAIT" : "LANDSCAPE";

  const onOrientationChange = () => {
    let height: number;

    /**
     * initWidth and initHeight are calculated on load.
     * Because calculate the width and height on orientation change
     * does not work inside an iframe we should use the initial values
     */
    if (
      (initOrientation === "PORTRAIT" && isPortrait()) ||
      (initOrientation === "LANDSCAPE" && !isPortrait())
    ) {
      // use the initial values
      height = initHeight;
    } else {
      // swap the values
      height = initWidth;
    }

    document.documentElement.style.setProperty("--innerHeight", `${height}px`);
  };

  const onWindowResizeHandler = () => {
    document.documentElement.style.setProperty(
      "--innerHeight",
      `${window.innerHeight}px`
    );
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResizeHandler);
    window.addEventListener("orientationchange", onOrientationChange);

    onOrientationChange();

    return () => {
      window.removeEventListener("resize", onWindowResizeHandler);
      window.removeEventListener("orientationchange", onOrientationChange);
    };
  }, []);

  return (
    <StyleContainer>
      <Fonts />
      <DisplayModeSwitcher />
      <ActivityMobile />
      <DialogMobile />
      <UiBlocker />
    </StyleContainer>
  );
};
